export enum PermissionFlags {
    MANAGE_SUBMISSIONS = 1 << 0,
    PASSWORD_LINKS = 1 << 1,
    STAFF_DASHBOARD = 1 << 2,
    BOT_CONTROL = 1 << 3,
    EXPERIMENTAL = 1 << 4,
    DELETE_USER = 1 << 5,
    AUTO_ACCEPT_SETTINGS = 1 << 6,
    SITE_SETTINGS = 1 << 7,
    MANAGE_TAGS = 1 << 8,
    MANAGE_ROLES = 1 << 9,
    BAN_USERS = 1 << 10,
    MANAGE_PACKS = 1 << 11,
    MANAGE_LISTS = 1 << 12,
    DELETE_LEVELS = 1 << 13,
    MANAGE_NOTES = 1 << 14,
    ADMIN = 1 << 15,
    SKIP_QUEUE = 1 << 16,
    BETA_ACCESS = 1 << 17,
    CREATE_SIGNUP_TOKEN = 1 << 18,
    VIEW_AUDIT_LOG = 1 << 19,
    MANAGE_FAVORITE_LEVELS = 1 << 20,
    MANAGE_DISCORD_INTEGRATION = 1 << 21,
}
